import React, { useEffect, useState } from "react";
import { getCookie } from "./WebAnalytic";

const WebAnalyticCookieTest = () => {
  const [testResult, setTestResult] = useState(null);

  useEffect(() => {
    const person = {
      accountId: "12345",
      gender: "male",
      title: "Engineer",
      affiliatedOrgId: "67890",
      personId: "123123123",
    };
    // const personType = "professional";
    const personType = "student";
    const action = "login";
    const appId = "app123";

    const cookieValue = getCookie(person, personType, action, appId);

    setTestResult(JSON.stringify(cookie));
    document.cookie = `TestWACookie=${cookieValue}; domain=${cookie.domain}; path=${cookie.path}`;
  }, []);

  return (
    <div>
      <h1>Test GetCookie Function</h1>
      {testResult ? <p>{testResult}</p> : <p>Running test...</p>}
    </div>
  );
};

export default WebAnalyticCookieTest;
